const loginFields=[
    {
        labelText:"Email address",
        labelFor:"email-address",
        id:"email-address",
        name:"email-address",
        type:"email-address",
        autoComplete:"email-address",
        isRequired:true,
        placeholder:"Email address"   
    },
    {
        labelText:"Password",
        labelFor:"password",
        id:"password",
        name:"password",
        type:"password",
        autoComplete:"current-password",
        isRequired:true,
        placeholder:"Password"   
    }
]

const signupFields=[
    {
        labelText:"Username",
        labelFor:"username",
        id:"username",
        name:"username",
        type:"text",
        autoComplete:"username",
        isRequired:true,
        placeholder:"Username"   
    },
    {
        labelText:"Email address",
        labelFor:"email",
        id:"email",
        name:"email",
        type:"email",
        autoComplete:"email",
        isRequired:true,
        placeholder:"Email address"   
    },  
    {
        labelText:"Org",
        labelFor:"org",
        id:"org",
        name:"org",
        type:"text",
        isRequired:true,
        placeholder:"organization"   
    },  
    {
        labelText:"workingliveId",
        labelFor:"workingliveId",
        id:"workingliveId",
        name:"workingliveId",
        type:"text",
        isRequired:true,
        placeholder:"workingliveId"   
    },
    {
        labelText:"providerId",
        labelFor:"providerId",
        id:"providerId",
        name:"providerId",
        type:"text",
        isRequired:true,
        placeholder:"providerId"   
    },    
    {
        labelText:"Password",
        labelFor:"password",
        id:"password",
        name:"password",
        type:"password",
        autoComplete:"current-password",
        isRequired:true,
        placeholder:"Password"   
    },
    {
        labelText:"Confirm Password",
        labelFor:"confirm-password",
        id:"confirm-password",
        name:"confirm-password",
        type:"password",
        autoComplete:"confirm-password",
        isRequired:true,
        placeholder:"Confirm Password"   
    }
]

const loginWithoutPassword=[
    {
        labelText:"Email address",
        labelFor:"email-address",
        id:"email-address",
        name:"email-address",
        type:"email-address",
        autoComplete:"email-address",
        isRequired:true,
        placeholder:"Email address"   
    }
]

export {loginFields,signupFields, loginWithoutPassword}